export const allowedPages = ['Category', 'Brand', 'Collection', 'Shop'];

export const allowedPagesWithAttributes = ['Category'];

export const allowedAttributes = [
  'product.brandName',
  'product.attribute.Tipo',
  'product.attribute.Material_del_tapiz',
  'product.attribute.Material_de_la_estructura',
  'product.attribute.Tipo_de_piel',
  'product.attribute.Procesador',
  'product.attribute.Cantidad_de_puertas',
  'product.attribute.Aro',
  'product.attribute.Tamaño_de_la_pantalla',
  'product.attribute.Número_de_quemadores',
  'product.attribute.Capacidad_de_lavado',
  'product.attribute.Número_de_puestos',
  'product.attribute.Memoria_RAM',
  'product.attribute.Número_de_hilos',
  'product.attribute.Número_de_puertas',
  'derived.product.Tamano_de_la_pantalla',
  'product.attribute.Tamaño_del_respaldo',
  'product.attribute.Resolución',
  'derived.product.Memoria_RAM',
];
